
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/local/[id]/about",
      function () {
        return require("private-next-pages/local/[id]/about/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/local/[id]/about"])
      });
    }
  